import { useEffect } from 'react';

/**
 * Simple hook to set page title for SEO
 * Usage: usePageTitle('Services | Northgate Web');
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
